import { useSystemDegradationStatus } from '@phx/maintenance';

import { useFlags } from './use-flags';

export const useAppSystemDegradationStatus = () => {
    const { lillySystemDegradationBanner } = useFlags();
    return useSystemDegradationStatus(lillySystemDegradationBanner);
};
